var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppDialog",
    {
      attrs: {
        activatorText: "New",
        title: _vm.title,
        action: "Add",
        "action-disabled": _vm.hasEmptyFields()
      },
      on: {
        action: function($event) {
          return _vm.handleAdd()
        },
        dialog: _vm.handleDialogChange
      }
    },
    [
      _c("v-text-field", {
        attrs: { label: "Name", solo: "" },
        model: {
          value: _vm.clinicalTrial.name,
          callback: function($$v) {
            _vm.$set(_vm.clinicalTrial, "name", $$v)
          },
          expression: "clinicalTrial.name"
        }
      }),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          items: _vm.anonymizationConfigs,
          "item-text": "name",
          label: "Anonymization Configuration",
          solo: "",
          "return-object": ""
        },
        model: {
          value: _vm.clinicalTrial.anonymizationConfig,
          callback: function($$v) {
            _vm.$set(_vm.clinicalTrial, "anonymizationConfig", $$v)
          },
          expression: "clinicalTrial.anonymizationConfig"
        }
      }),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          items: _vm.availableCenters,
          "item-text": "name",
          label: "Centers",
          multiple: "",
          chips: "",
          solo: "",
          "return-object": ""
        },
        on: { change: this.handleAddCenter },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("v-chip", {
                  staticClass: "white--text secondary--text",
                  domProps: { textContent: _vm._s(item.name) }
                })
              ]
            }
          }
        ]),
        model: {
          value: _vm.clinicalTrial.centers,
          callback: function($$v) {
            _vm.$set(_vm.clinicalTrial, "centers", $$v)
          },
          expression: "clinicalTrial.centers"
        }
      }),
      _vm._v(" "),
      _vm.clinicalTrial.trialCenters.length > 0
        ? _c(
            "div",
            { staticClass: "pb-5" },
            _vm._l(_vm.clinicalTrial.trialCenters, function(trialCenter) {
              return _c(
                "v-row",
                { key: trialCenter.centerId, staticClass: "flex" },
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Center Name",
                          value: _vm.clinicalTrial.centers.find(function(
                            center
                          ) {
                            return center.id === trialCenter.centerId
                          }).name,
                          outlined: "",
                          dense: "",
                          disabled: "",
                          "hide-details": ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Trial Center Id",
                          outlined: "",
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: trialCenter.trialCenterId,
                          callback: function($$v) {
                            _vm.$set(trialCenter, "trialCenterId", $$v)
                          },
                          expression: "trialCenter.trialCenterId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "AE Title", solo: "" },
        model: {
          value: _vm.clinicalTrial.AETitle,
          callback: function($$v) {
            _vm.$set(_vm.clinicalTrial, "AETitle", $$v)
          },
          expression: "clinicalTrial.AETitle"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "Port", solo: "", type: "number" },
        model: {
          value: _vm.clinicalTrial.port,
          callback: function($$v) {
            _vm.$set(_vm.clinicalTrial, "port", $$v)
          },
          expression: "clinicalTrial.port"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "IP", solo: "" },
        model: {
          value: _vm.clinicalTrial.ip,
          callback: function($$v) {
            _vm.$set(_vm.clinicalTrial, "ip", $$v)
          },
          expression: "clinicalTrial.ip"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }